import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { environment } from '../../environments/environment';
import { RequestTools } from './request.tools';
import { ApiV6Service } from './apiv6.service';
import { MessagesService } from '@core/_services/messages.service';
import {
    storeData,
    getPageFromType,
    getArrayField,
    formatVariable,
    decodeUtf8,
    convertStringToBoolean,
} from '@core/_utils/tools.utils';
import {
    defaultPage,
    InputStyle,
    tokenName,
} from '@documalis/_const/const';
import { TokenService } from '@core/_services/token.service';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, lastValueFrom, map } from 'rxjs';
import {LayoutService} from "../layout/service/app.layout.service";
import { NotificationService } from './notification.service';
import { storeBaskets } from '@core/_utils/basket.utils';
import { Communication } from './communication';
import { LoadingService } from '@core/_services/loading.service';
import { IndexedDbService } from './indexeddb.service';
import { CheckTools } from "@service/check.tools";

@Injectable()
export class ConnectService {
    public displayModal = false;
    public urlServer = environment.apiUrl;
    public errMessage = '';

    public data: any;
    public error = false;
    public userTheme: string = '';
    public menuTheme: string = '';
    public topBarTheme: string = '';
    public scale:string = '';
    public menuStyle: string;
    public inputStyle: any;
    public currentLanguage: string;
    private defaultPage: string;
    private internal: any;
    private dataLoaded = false;

    constructor(
        private http: HttpClient,
        public menu: MenuServiceInt,
        private api: ApiV6Service,
        private requestTools: RequestTools,
        protected _messageService: MessagesService,
        private token: TokenService,
        public translate: TranslateService,
        private layoutService: LayoutService,
        private notificationService: NotificationService,
        protected comm: Communication,
        private loadingService: LoadingService,
        private indexedDbService: IndexedDbService,
        private checkTools: CheckTools,
    ) {
        this.menu.display = false;
        this.defaultPage = defaultPage;
        this.menuStyle = this.layoutService.config().menuMode;
        this.topBarTheme = this.layoutService.config().topbarTheme;
        this.menuTheme = this.layoutService.config().menuTheme;
        this.userTheme = this.layoutService.config().componentTheme;
        this.inputStyle = this.layoutService.config().inputStyle;
        this.scale = this.layoutService.config().scale.toString();
        this.internal = {};
        this.dataLoaded = false;
    }

    public getBackGroundImage() {
        return this.api.execGetUrlGedAction('getbackgroundimg', '');
    }

    public getLogo() {
        return this.api.execGetUrlGedAction('getlogo', '');
    }

    public async connect(identifiant, password, aCrypted, aDisp, aSSO, callBack) {
        let wRes: any;
        let wReset = false;
        this.defaultPage = defaultPage;
        this.indexedDbService.initialize();
        wRes = false;
        wRes = await this.execConnect(identifiant, password, aCrypted, aDisp, aSSO);
        if (wRes === false) {
            if (this.errMessage !== '') {
                wReset = true;
            }
            return this.resultConnect(wRes, wReset, this.defaultPage, this.errMessage);
        }
        wRes = await this.connectTokenOk(identifiant, callBack);
        return wRes;
    }

    private async connectTokenOk(aIdentifiant, callBack) {
        let wRes: any;
        let wResB: any;
        let wPref: any;
        let wInternalPref = {};
        let wbskList = [];
        let wbskListUser = [];
        let wbskListGroup = [];
        let wDbversion: any;
        wPref = null;
        wRes = false;

        if (!('indexedDB' in window)) {
            console.log("This browser doesn't support IndexedDB");
            this._messageService.addErrorMsg(this.translate.instant("Error_IDB"));
            return false;
        }

        wDbversion = localStorage.getItem('databaseversion');
        if (wDbversion !== undefined && wDbversion !== null) {
            this.indexedDbService.version = wDbversion;
            this.dataLoaded = true;
        }
        
        try {
            wRes = await lastValueFrom(this.readAll());
            this.checkTools.checkFork(wRes);
            if (this.checkTools.getRes() === false) {
                throw new Error(this.checkTools.getMsgError());
            }
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant(error.message));
            wRes = this.resultConnect(false, false, this.defaultPage, this.errMessage);
            if (wRes.result === false) {
                return wRes;
            }
        }

        if (this.dataLoaded === false) {
            this.loadingService.loading = true;
            wResB = await this.storeListVariable(wRes.getVariableList);
            if (wResB === false) {
                this._messageService.addErrorMsg(this.translate.instant("Error_G"));
                this.loadingService.loading = false;
                return {result: false};
            }
            wResB = await this.storeGrpVariable(wRes.getGroupVariableList);
            if (wResB === false) {
                this._messageService.addErrorMsg(this.translate.instant("Error_G"));
                this.loadingService.loading = false;
                return {result: false};
            }

        }
        await this.indexedDbService.getVariables();

        await this.indexedDbService.getGroupVariables();

        this.internal.internalcfg = wRes.getConfigGeneral.delay;
        this.internal.maxload = wRes.getConfigGeneral.maxUpload;
        this.internal.allowpref = wRes.getConfigGeneral.allowPref;
        this.internal.allowSendNotif = wRes.getConfigGeneral.allowSendNotif;
        this.internal.titleCust = wRes.getConfigGeneral.titleCust;
        this.internal.bskMailColor = wRes.getConfigGeneral.bskMailColor;
        this.internal.bskCollectColor = wRes.getConfigGeneral.bskCollectColor;
        this.internal.bskPublishColor = wRes.getConfigGeneral.bskPublishColor;
        this.internal.bskActionColor = wRes.getConfigGeneral.bskActionColor;
        this.internal.bskInputColor = wRes.getConfigGeneral.bskInputColor;
        this.internal.bskOutputColor = wRes.getConfigGeneral.bskOutputColor;
        this.internal.bskSystemColor = wRes.getConfigGeneral.bskSystemColor;
        this.internal.currentLanguage = this.currentLanguage;

        this.internal.extension = wRes.getConfigGeneral.allowPref;

        wRes.getUserInfos.User.Information.FirstName = decodeUtf8(wRes.getUserInfos.User.Information.FirstName);
        wRes.getUserInfos.User.Information.LastName = decodeUtf8(wRes.getUserInfos.User.Information.LastName);
        this.internal.internal = wRes.getUserInfos.User.Information;
        this.internal.discntAzure = wRes.getConfigGeneral.discntAzure;
        this.internal.toastDurationValue = wRes.getConfigGeneral.toastDurationValue;
        this.internal.bskDockReorder = wRes.getConfigGeneral.bskDockReorder;
        this.internal.srcDockReorder = wRes.getConfigGeneral.srcDockReorder;
        this._messageService.setToastDuration(wRes.getConfigGeneral.toastDurationValue);
        storeData('intern', btoa(JSON.stringify(this.internal)));        

        wRes.getUserPreference.data.map((item) => {
            this.affectValue(item, wInternalPref);
        });
        storeData('internalprefusr', btoa(JSON.stringify(wInternalPref)));

        wbskList = storeBaskets(wRes.getBasketListbyUser, this.api, '');        
        wbskListUser = storeBaskets(wRes.getUserBaskets.data, this.api, 'user');    
        wbskListGroup = storeBaskets(wRes.getGroupBaskets.data, this.api, 'group');
        
        storeData('listtagbsk', JSON.stringify(wRes.getGroupBaskets.data.ListTagBsk));    
        storeData('taglistgroup', JSON.stringify(wRes.getGroupBaskets.data.TagListGroup));    

        if (this.dataLoaded === false) {
            this.loadingService.loading = true;
            wResB = await this.indexedDbService.storeBasketdb(wbskList, wbskListUser, wbskListGroup);
            if (wResB === false) {
                this._messageService.addErrorMsg(this.translate.instant("Error_G"));
                this.loadingService.loading = false;
                return {result: false};
            }
        }

        if (this.dataLoaded === false) {
            storeData('databaseversion', this.indexedDbService.version);
        }

        storeData('bskcolorlist', JSON.stringify(wRes.getBskColorlist.data));        

        this.notificationService.setNotifyList(wRes.getActivNotifList);
        storeData('notifylist', JSON.stringify(this.notificationService.notifList));
        this.notificationService.initialize();

        wRes = await this.menu.setMenuItem();
        if (wRes === false) {
            return {result: false};
        }

        this.menu.menuTheme = this.menuTheme;
        this.menu.display = true;
        this.menu.userName = this.token.getFirstLastName();
        this.menu.menuMode = this.menuStyle;
        this.layoutService.config().inputStyle = this.inputStyle;
        this.menu.topBarTheme = this.topBarTheme;

        if (getArrayField(this.menu.userName) === '') {
            this.menu.userName = aIdentifiant;
        }

        if (this.userTheme === '') {
            this.userTheme = this.layoutService.config().componentTheme;
        }

        if (this.menuTheme === '') {
            this.menuTheme = this.layoutService.config().menuTheme;
        }

        if (this.topBarTheme === '') {
            this.topBarTheme = this.layoutService.config().topbarTheme;
        }

        try {
            wPref = JSON.parse(localStorage.getItem('preference'));
            if (wPref !== null) {
                if (wPref.theme !== this.userTheme) {
                    wPref.theme = this.userTheme;
                }
                if (wPref.menuTheme !== this.menuTheme) {
                    wPref.menuTheme = this.menuTheme;
                }             
                if (wPref.menuStyle !== this.menuStyle) {
                    wPref.menuStyle = this.menuStyle;
                }
                if (wPref.inputStyle !== this.inputStyle) {
                    wPref.inputStyle = this.inputStyle;
                }
                if (wPref.topBarTheme !== this.topBarTheme) {
                    wPref.topBarTheme = this.topBarTheme;
                }
                if (wPref.scale !== this.scale) {
                    wPref.scale = this.scale;
                }
            } else {
                wPref = {
                    theme: this.userTheme,
                    menuTheme: this.menuTheme,
                    menuStyle: this.menuStyle,
                    inputStyle: this.inputStyle,
                    topBarTheme: this.topBarTheme,
                    scale: this.scale,
                };
            }
            storeData('preference', JSON.stringify(wPref));
            this.layoutService.config().inputStyle = InputStyle[wPref.inputStyle];
            this.menu.changeTheme(wPref.theme);
            this.menu.changeScale(wPref.scale);
        } catch (e) {
            console.log('ConnectService connectTokenOk catch', e);
        }
        return this.resultConnect(true, false, this.defaultPage, this.errMessage);
    }

    private readAll() {
        const wDataRequest = { typefilter: '*'};
        return forkJoin([
            this.api.execUrlAction('getconfiggeneral', ''),
            this.api.execUrlAction('getuserinfos', {}),
            this.api.execUrlAction('getvariablelist', ''),
            this.api.execUrlAction('getgroupvariablelist', ''),
            this.api.execUrlAction('getuserpreference', ''),
            this.api.execUrlAction('getbasketlistbyuserrequest', wDataRequest),
            this.api.execUrlAction('getuserbaskets', ''),
            this.api.execUrlAction('getgroupbaskets', ''),            
            this.api.execUrlAction('getbskcolorlist', ''),
            this.api.execUrlAction('getactivnotiflist', '')
        ]).pipe(
            map(([getConfigGeneral, getUserInfos, getVariableList, getGroupVariableList, getUserPreference,
                getBasketListbyUser, getUserBaskets, getGroupBaskets, getBskColorlist, getActivNotifList]) => {
                return {getConfigGeneral, getUserInfos, getVariableList, getGroupVariableList, getUserPreference,
                    getBasketListbyUser, getUserBaskets, getGroupBaskets, getBskColorlist, getActivNotifList};
            })
        );
    }

    private resultConnect(aSuccess, aReset, aPage, aMsgErr) {
        return {
            result: aSuccess,
            reset: aReset,
            page: aPage,
            errMessage: aMsgErr,
        };
    }
    private async execConnect(identifiant, password, aAuto, aDisp, aFormAzure) {
        interface ApiResponse {
            token: string;
            username: string;
        }
        let wRes: any;
        const formData = new FormData();
        formData.append('username', identifiant);
        formData.append('pass', password);
        formData.append('crypted', aAuto);
        formData.append('api', aDisp);
        formData.append('sso', aFormAzure);
        this.errMessage = '';

        try {
            wRes = await lastValueFrom(this.comm.postUrl('/api/token', formData));
            if (wRes) {
                localStorage.setItem(tokenName, JSON.stringify(wRes));
                this.data = wRes;
                return true;
            }
            return false;
        } catch (error) {
            console.log('execConnect catch', error.error);
            switch (error.status) {
                case 500:
                    this.errMessage = this.translate.instant('Server_KO');
                    this._messageService.addErrorMsg(this.errMessage,this.translate.instant('Server_KO'));
                    return false;                    
                case 403:
                    this.errMessage = this.translate.instant('ErrorCode.' + error.error.errorcode);
                    this._messageService.addErrorMsg(this.errMessage,this.translate.instant('Error_G'));
                    return false;                    
                default:
                    if (error.error.token === 'undefined') {
                        this.errMessage = this.translate.instant('Token_KO_2');
                        this._messageService.addErrorMsg(this.errMessage,this.translate.instant('Server_KO'));
                        return false;
                    } else {
                        this.errMessage = this.translate.instant('Token_KO_1');
                        this._messageService.addErrorMsg(this.errMessage,this.translate.instant('Server_KO'));
                        return false;
                    }                    
            }
        }
    }

    public async execCheckConnect(identifiant) {
        let wRes: any;
        const formData = new FormData();
        formData.append('login', identifiant);
        this.errMessage = '';
        try {
            wRes = await lastValueFrom(this.comm.postUrl('/api/check', formData));
            if (wRes.data === '0') {
                return false;
            }
            return true;
        } catch (error) {
            console.log('execCheckConnect catch', error.message);
            this.errMessage = error.message;
            this._messageService.addErrorMsg(this.errMessage,this.translate.instant('Error_G')); 
            return false;
        }
    }

    public async verifyResetPwd(identifiant) {
        return await this.requestTools.verifyResetPwd(identifiant);
    }

    public async getContent(aData) {
        return await lastValueFrom(this.comm.getUrl
            ('/content?Content=' + aData))
            .catch((error) => {
                console.log('getContent catch', error);
                return false;
            })
            .then((res: any) => {
                return res;
            });
    }

    private affectValue(aItem, aInternalPref) {
        switch (aItem.typepref) {
            case 0: {
                this.defaultPage = getPageFromType(aItem.datapref);
                aInternalPref.defaultPage = this.defaultPage
                break;
            }
            case 1: {
                this.userTheme = aItem.datapref;
                break;
            }
            case 2: {
                aInternalPref.emptyBsk = convertStringToBoolean(aItem.datapref);
                break;
            }
            case 3: {
                this.menuTheme = aItem.datapref;
                break;
            }
            case 4: {
                this.menuStyle = aItem.datapref;
                break;
            }
            case 5: {
                aInternalPref.gradBsk = convertStringToBoolean(aItem.datapref);
                break;
            }            
            case 9: {
                aInternalPref.bskLoadMax = aItem.datapref;
                break;
            }
            case 20: {
                aInternalPref.bskNextVal = convertStringToBoolean(aItem.datapref);
                break;
            }
            case 21: {
                this.topBarTheme = aItem.datapref;
                break;
            }
            case 22: {
                this.scale = aItem.datapref;
                break;
            }
            case 26: {
                aInternalPref.modeView = aItem.datapref;
                break;
            }
            case 43: {
                aInternalPref.modeViewDoc = aItem.datapref;
                break;
            }
            case 44: {
                aInternalPref.defaultFullTextDate = aItem.datapref;
                break;
            }
            case 45: {
                this.inputStyle = aItem.datapref;
                break;
            }
            case 54: {
                aInternalPref.bskCompact = convertStringToBoolean(aItem.datapref);
                break;
            }
            case 55: {
                aInternalPref.extension = aItem.datapref;
                break;
            }
            case 58: {
                aInternalPref.displayConfirm = convertStringToBoolean(aItem.datapref);
                break;
            }
            case 59: {
                aInternalPref.requestOrder = convertStringToBoolean(aItem.datapref);
                break;
            }              
        }
    }

    private async storeVariable(res) {
        let wRes: any;
        if (res.VariableList.Variable !== undefined) {
            wRes = await this.indexedDbService.addDataIndexedDb('variables', [{id: 'variables', value:formatVariable(res.VariableList.Variable)}]);
        } else {
            wRes = await this.indexedDbService.addDataIndexedDb('variables', [{id: 'variables', value: []}]);
        }
        return wRes;
    }

    private async storeListVariable(aRes) {
        let wRes: any;
        if (!Array.isArray(aRes.VariableList)) {
            if (Array.isArray(aRes.VariableList.Variable)) {
                aRes.VariableList.Variable.map((item) => {
                    return formatVariable(item);
                });
                wRes = await this.indexedDbService.addDataIndexedDb('variables', [{id: 'variables', value: aRes.VariableList}]);
            } else {
                wRes = await this.storeVariable(aRes);
            }
        } else {
            wRes = await this.storeVariable(aRes);
        }
        return wRes;
    }

    private async storeGrpVariable(aRes) {
        let wRes: any;
        if (aRes.GroupVariableList.GroupVariable) {
            if (Array.isArray(aRes.GroupVariableList.GroupVariable)) {
                aRes.GroupVariableList.GroupVariable.map((item) => {
                    if (item.VariableList && !Array.isArray(item.VariableList)) {
                        if (Array.isArray(item.VariableList.Variable)) {
                            item.VariableList.Variable.map((elem) => {
                                return formatVariable(elem);
                            });
                        } else {
                            item.VariableList.Variable = formatVariable(item.VariableList.Variable);
                        }
                    }
                });
                wRes = await this.indexedDbService.addDataIndexedDb('groupvariable', [{id: 'groupvariable', value: aRes.GroupVariableList}]);
            } else {
                if (
                    aRes.GroupVariableList.GroupVariable.VariableList &&
                    !Array.isArray(aRes.GroupVariableList.GroupVariable.VariableList)
                ) {
                    if (Array.isArray(aRes.GroupVariableList.GroupVariable.VariableList.Variable)) {
                        aRes.GroupVariableList.GroupVariable.VariableList.Variable.map((elem) => {
                            return formatVariable(elem);
                        });
                    } else {
                        aRes.GroupVariableList.GroupVariable.VariableList.Variable = formatVariable(
                            aRes.GroupVariableList.GroupVariable.VariableList.Variable
                        );
                    }
                    wRes = await this.indexedDbService.addDataIndexedDb('groupvariable', [{id: 'groupvariable', value: aRes.GroupVariableList}]);
                } else {
                    wRes = await this.indexedDbService.addDataIndexedDb('groupvariable', [{id: 'groupvariable', value: []}]);
                }
            }
        } else {
            wRes = await this.indexedDbService.addDataIndexedDb('groupvariable', [{id: 'groupvariable', value: []}]);
        }
        return wRes;
    } 
}
